<template>
  <ConfirmPopup></ConfirmPopup>
  <Panel header="Đặt lịch khám">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col p-col-12 p-md-12 p-lg-12" v-if="follow">
        <label>Vui lòng quan tâm ZaloOA của Trung tâm Y tế Hòa Vang và cung cấp thông tin để hoàn thành đăng ký khám bệnh.</label>
        <Button severity="warning" label="Mở ZaloOA"  icon="pi pi-external-link" @click="openLink()"></Button>
      </div>
      <div class="p-field p-col p-col-12 p-md-6 p-lg-6">
        <label>Họ và tên</label>
        <InputText id="fullname" type="text" v-model="register.customerName" style="text-align: left"/>
        <small id="fullname-note" class="p-error" v-if="!register.customerName">* Vui lòng cung cấp họ và tên</small>
      </div>
      <div class="p-field p-col-12 p-sm p-md-6">
        <label for="year">Chọn năm sinh:</label>
        <Calendar
            id="year"
            v-model="register.year"
            view="year"
            dateFormat="yy"
            :manualInput="true"
        />
        <small id="year-note1" class="p-error" v-if="!register.year">* Vui lòng chọn năm sinh</small>
      </div>
      <div class="p-field p-col p-col-12 p-md-6 p-lg-6">
        <label>Số điện thoại</label>
        <InputText id="phoneNumber" type="text" v-model="register.phoneNumber" style="text-align: left"/>
        <small id="phone-note1" class="p-error" v-if="!register.phoneNumber" style="text-align: left">* Vui lòng cung cấp số điện thoại</small>
      </div>
      <div class="p-field p-col p-col-12 p-md-6 p-lg-6">
        <label>Yêu cầu khám của bạn(không bắt buộc)</label>
        <InputText id="message" type="text" v-model="register.message" style="text-align: left"/>
      </div>
      <div class="p-field p-col-12 p-sm p-md-6">
        <label for="dateBooking">Chọn ngày khám:</label>
        <Calendar
            id="dateBooking"
            v-model="register.timeBooking"
            selectionMode="single"
            dateFormat="dd/mm/yy"
            :showButtonBar="true"
            :showIcon="true"
            :manualInput="false"
            :monthNavigator="true"
            :yearNavigator="true"
            :minDate="minDate"
            yearRange="1900:2050"
        />
        <small id="id-note1" class="p-error" v-if="!register.timeBooking">* Vui lòng chọn ngày đặt lịch khám</small>
      </div>
      <div class="p-field p-col-12 p-sm p-md-6">
        <label>Chọn giờ khám</label>
        <Dropdown id="hourselect" v-model="register.hour" :options="gioDatLich" optionLabel="value" optionValue="value" :filter="true">
        </Dropdown>
      </div>
    </div>
<!--    <div class="p-field p-col-12 p-sm p-md-4">-->
    <Button label="Đặt lịch" icon="pi pi-plus-circle" :disabled="!valid()" @click="addRegister()"  style="margin-right: 20px"/>

<!--    </div>-->
  </Panel>
</template>

<script lang="ts">

import {computed, ref} from 'vue'
import {useToast} from "primevue/usetoast";
import moment from 'moment';
import {RegisterServiceByWeb} from "@/models/registerServiceByWeb";
import zaloRepository from "@/services/ZaloRepository";
import router from "@/router";

export default {
  setup(props){
    const toast = useToast();
    const register = ref({} as RegisterServiceByWeb);
    register.value.hour = 0;
    const follow = ref(false);
    const gioDatLich = ref([
      {value: 7},
      {value: 8},
      {value: 9},
      {value: 10},
      {value: 11},
      {value: 12},
      {value: 13},
      {value: 14},
      {value: 15},
      {value: 16},
      {value: 17},
    ]);

    const toTimestamp = (strDate) => {
      const dt = Date.parse(strDate);
      return dt / 1000;
    }

    const formatDateTime = (date) => {
      return moment(String(date)).format('YYYY-MM-DD');
    };
    const minDate = ref(new Date());
    const addRegister = () => {
      follow.value = false;
      register.value.serviceName = "Đặt lịch khám";
      register.value.serviceCode = "#datlichkham";
            zaloRepository.registerServiceByWeb(register.value)
                .then((response) => {
                  toast.add({
                    severity: 'success',
                    summary: 'Thành công',
                    detail: 'Đăng ký khám bệnh thành công',
                    life: 2000
                  });
                  const temp = ref({} as RegisterServiceByWeb);
                  register.value = temp.value;
                  register.value.hour = 0;
                })
                .catch(err => {
                  follow.value = true;
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
  }
    const valid = ()=> { return register.value.customerName && register.value.year && register.value.phoneNumber && register.value.timeBooking};
    const openLink = () => {
      window.open("http://zalo.me/4460758436706775982", '_blank');
    };

    return {
      register,
      minDate,
      addRegister,
      valid,
      follow,
      openLink,
      gioDatLich
      // nonAccentVietnamese
    }
  }

}
</script>
<style lang="scss">
 label{
   margin-bottom: 8px;
  text-align: initial;
  font-weight: bold;
  margin: 0;
  /*    !*font-size: 13px;*!*/
  }
</style>